import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "animate.css";

import resume from "../../images/resume.pdf";

function Header({ isActive, light, logoSource, bootstrapNav, current }) {
  const [toggleNavbar, setToggleNavbar] = useState(false);
  const [display, setDisplay] = useState("none");

  useEffect(() => {
    isActive ? setDisplay("block") : setDisplay("none");
  }, [isActive]);

  const handleMobilenav = (e) => {
    e.preventDefault();
    setToggleNavbar(!toggleNavbar);
  };

  /*const handleMobileClasses = () => {
    let classes = 'desktop-header-3 fixed-top';
    console.log(toggleNavbar);
    if(!toggleNavbar) {
      console.log('toggleNavbar: ', toggleNavbar);
      classes = 'desktop-header-3 fixed-top'
    }
    else {
      console.log('toggleNavbar: ', toggleNavbar, '==> open');
      classes += ' mobile-header-open'
    }
    
    return classes;
  };*/

  document.addEventListener("click", function (e) {
    if (e.target.closest(".content-3")) {
      setToggleNavbar(false);
    }
  });

  return (
    <header
      style={{ display: display }}
      className="desktop-header-3 fixed-top animate__animated animate__fadeInDown"
    >
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-dark">
          <Link
            className="nav-link logo-nav"
            to="/"
            spy={true}
            smooth={true}
            duration={500}
          >
            quanle
          </Link>
          <button
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
            className="navbar-toggler"
            data-target="#navbarNavDropdown"
            data-toggle="collapse"
            type="button"
            onClick={handleMobilenav}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={
              toggleNavbar
                ? "collapse navbar-collapse show "
                : "collapse navbar-collapse"
            }
            id="navbarNavDropdown"
          >
            <ul className="navbar-nav ml-auto scrollspy">
              <li className="nav-item">
                <Link
                  className={
                    current === "about" ? "nav-link active" : "nav-link"
                  }
                  to="/about"
                  spy={true}
                  smooth={true}
                  title="About me"
                  duration={500}
                >
                  .about()
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={
                    current === "works" ? "nav-link active" : "nav-link"
                  }
                  to="/works"
                  spy={true}
                  smooth={true}
                  title="Works"
                  duration={500}
                >
                  .work()
                </Link>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  title="mailto:quan.le1926@gmail.com"
                  href="mailto:quan.le1926@gmail.com"
                >
                  .contact()
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  href={resume}
                  target="_blank"
                  title="See my Resume"
                  className="btn btn-resume"
                >
                  Resume
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
